import { usePathname, useSearchParams } from 'next/navigation';
import { type PageTrackingTypes, PageType, TemplateType } from '@pkgs/components/types/tracking';

const LIPA_FILTER_NAMES = ['shopIds', 'masterDataLiPaIds', 'masterDataShopIds'] as const;

const ROUTE_TRACKING_TYPES: Record<string, PageTrackingTypes> = {
  propertysearch: { pageType: PageType.SEARCH_RESULT, templateType: TemplateType.SEARCH_RESULT },
  exposes: { pageType: PageType.EXPOSE, templateType: TemplateType.EXPOSE },
  projects: { pageType: PageType.DEVELOPMENT_EXPOSE, templateType: TemplateType.EXPOSE },
};

export const usePageTrackingTypes = (): PageTrackingTypes | undefined => {
  // Pages Router compatibility can make these null while both routers coexist.
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const routeSegment = pathname?.split('/')[3]?.replace(/-app$/, '');

  if (
    routeSegment === 'propertysearch' &&
    searchParams &&
    LIPA_FILTER_NAMES.some((filterName) => searchParams.has(filterName) || searchParams.has(`${filterName}[]`))
  ) {
    return { pageType: PageType.LIPA_SEARCH_RESULT, templateType: TemplateType.SEARCH_RESULT };
  }

  return routeSegment ? ROUTE_TRACKING_TYPES[routeSegment] : undefined;
};
